"use strict";
import { useContext } from "react";
import { ShellContext } from "../context";
export function useShellRootPath() {
  const { rootPath } = useContext(ShellContext);
  return rootPath;
}
